<template>
  <toast
    v-for="(toast, index) in reversedToasts"
    :key="index"
    :classes="'bg-' + (toast.type === 'error' ? 'danger' : toast.type) + ' text-white'"
    :toast="{ message: toast.message }"
    :visible="visible"
    :delay="3000 + (toasts.length - index - 1) * 1000"
  ></toast>
</template>

<script>
import Toast from '@kanrisha/components/Base/Toast';

export default {
  components: {
    Toast,
  },
  props: {
    classes: {
      type: String,
      default: 'bg-success text-white',
    },
    visible: {
      type: Boolean,
      default: true,
    },
    toasts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    reversedToasts() {
      return Object.values(this.toasts).slice().reverse();
    },
  },
  setup() {
    return {};
  },
};
</script>
